import { Heading } from '@core/ui';
import { HeadingProps } from './types';

export const ProfileHeading = ({ title }: HeadingProps) => <Heading variant="h1">{title}</Heading>;
